export default __webpack_public_path__ + "static/media/web-developers-illustration.7d45d3cb.jpg";